import { Patient } from 'fhir/r4';

export type GenderType = 'male' | 'female' | 'other' | 'unknown';
export interface FamilyGroup {
  name: string;
  lastname: string;
  identifier: string;
  birthDate: string;
  gender: string;
  active: boolean;
  healthcareInsurance: string;
  phone?: string;
  email?: string;
}

export interface Favorite {
  identifier: string;
  name: string;
  type: string;
}

interface Verifier {
  data: {
    active: boolean;
  };
  issuer: string;
  timestamp: Date;
  value: boolean;
}

export interface PatientStateInterface extends Patient {
  owner_id: string[];
  metaSnabb: {
    healthcareInsurance?: string;
    verified?: Verifier[];
    group?: FamilyGroup[];
    favorites?: Favorite[];
  };
}

export function stateInit(): PatientStateInterface {
  return {
    resourceType: 'Patient',
    id: undefined,
    active: false,
    identifier: [],
    name: [],
    telecom: [],
    gender: undefined,
    birthDate: undefined,
    address: [],
    maritalStatus: undefined,
    generalPractitioner: [],
    owner_id: [],
    extension: [],
    metaSnabb: {}
  };
}
